import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminResultsPerPageSelector = ({
  updateResultsPerPageSetting,
  perPage,
  handleChangePerPage,
}) => {
  const intl = useIntl();

  const updatePerPage = (e) => {
    updateResultsPerPageSetting();
    handleChangePerPage(Number(e.target.value));
  };

  return (
    <div className="page-results">
      <span>
        {intl.formatMessage({ defaultMessage: 'Show per page:' })}
      </span>
      <Input
        type="select"
        className="custom-select"
        name="pageResults"
        id="selectPageResults"
        onChange={updatePerPage}
        value={perPage}
      >
        <option value="20">20</option>
        <option value="40">40</option>
        <option value="60">60</option>
        <option value="80">80</option>
        <option value="100">100</option>
      </Input>
    </div>
  );
};

const mapDispatchToProps = () => ({
  updateResultsPerPageSetting: () => {
    // @TODO: updating user preferences
    // dispatch();
  },
});

AdminResultsPerPageSelector.propTypes = {
  updateResultsPerPageSetting: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(AdminResultsPerPageSelector);
